// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-bg {
    background-color: #000;
    width: 100%;
    height: 50px;
}

.navbar-home {
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    /* max-width: 1200px; */
    max-width: 80%;
    margin: auto;
}

.navbar-data {
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    max-width: 90%;
    margin: auto;
}

.logo a {
    font-size: 25px;
    font-weight: bold;
    line-height: 50px;
}

.navbar-menu {
    gap: 0;
    list-style: none;
    margin: 0;
    display: flex;
}

.navbar-menu a {
    font-size: 14px;
    font-weight: 600;
    display: block;
    line-height: 50px;
    padding: 0 15px;
    border-radius: 0;
    transition: background 0.3s ease;
}

.navbar-menu a:hover,
.navbar-menu a:focus {
    background: #62a1d4;
}

/* Dropdown styles */
.navbar-menu li {
    position: relative;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #333;
    min-width: 200px;
    z-index: 1000;
    display: none;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    padding: 0;
    margin: 0;
    list-style: none;
}

.dropdown-menu li {
    padding: 0;
}

.dropdown-menu a {
    padding: 10px 15px;
    line-height: 1.5;
    white-space: nowrap;
    display: block;
    color: #fff;
    text-decoration: none;
}

.navbar-menu li:hover .dropdown-menu {
    display: block;
}

.dropdown-menu a:hover {
    background-color: #62a1d4;
}

.bi-chevron-compact-down {
    font-weight: bold;
    margin-left: 5px;
    font-size: 12px;
}

.collapse-menu {
    display: none;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    border: 0;
    background-color: #fff;
    padding: 5px;
    border-radius: 5px;
}

.collapse-menu:hover,
.collapse-menu:focus-visible {
    background-color: #e6e6e6;
    outline: 2px solid #62a1d4;
    outline-offset: 2px;
}

.collapse-menu .bar {
    width: 25px;
    height: 3px;
    background-color: #555;
    border-radius: 2px;
}

@media (max-width: 768px) {
    .navbar-home,
    .navbar-data {
        box-sizing: border-box;
        max-width: none;
        width: 100%;
        padding: 0 20px;
    }

    .navbar-menu {
        display: none;
    }

    .navbar-menu.is-open {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50px;
        left: 0;
        width: 100%;
        padding: 0;
        background-color: #000;
        box-shadow: 0 4px 8px rgba(0,0,0,0.3);
        z-index: 2000;
    }

    .navbar-menu.is-open > li {
        width: 100%;
    }

    .navbar-menu.is-open a {
        line-height: 1.4;
        padding: 14px 20px;
    }

    .navbar-menu.is-open .dropdown-menu {
        position: static;
        display: block;
        min-width: 0;
        box-shadow: none;
    }

    .navbar-menu.is-open .dropdown-menu a {
        padding-left: 40px;
    }

    .collapse-menu {
        display: flex;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,MAAM;IACN,gBAAgB;IAChB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,qCAAqC;IACrC,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI;;QAEI,sBAAsB;QACtB,eAAe;QACf,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,WAAW;QACX,UAAU;QACV,sBAAsB;QACtB,qCAAqC;QACrC,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".navbar-bg {\n    background-color: #000;\n    width: 100%;\n    height: 50px;\n}\n\n.navbar-home {\n    color: #fff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    /* max-width: 1200px; */\n    max-width: 80%;\n    margin: auto;\n}\n\n.navbar-data {\n    color: #fff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    max-width: 90%;\n    margin: auto;\n}\n\n.logo a {\n    font-size: 25px;\n    font-weight: bold;\n    line-height: 50px;\n}\n\n.navbar-menu {\n    gap: 0;\n    list-style: none;\n    margin: 0;\n    display: flex;\n}\n\n.navbar-menu a {\n    font-size: 14px;\n    font-weight: 600;\n    display: block;\n    line-height: 50px;\n    padding: 0 15px;\n    border-radius: 0;\n    transition: background 0.3s ease;\n}\n\n.navbar-menu a:hover,\n.navbar-menu a:focus {\n    background: #62a1d4;\n}\n\n/* Dropdown styles */\n.navbar-menu li {\n    position: relative;\n}\n\n.dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: #333;\n    min-width: 200px;\n    z-index: 1000;\n    display: none;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.2);\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n.dropdown-menu li {\n    padding: 0;\n}\n\n.dropdown-menu a {\n    padding: 10px 15px;\n    line-height: 1.5;\n    white-space: nowrap;\n    display: block;\n    color: #fff;\n    text-decoration: none;\n}\n\n.navbar-menu li:hover .dropdown-menu {\n    display: block;\n}\n\n.dropdown-menu a:hover {\n    background-color: #62a1d4;\n}\n\n.bi-chevron-compact-down {\n    font-weight: bold;\n    margin-left: 5px;\n    font-size: 12px;\n}\n\n.collapse-menu {\n    display: none;\n    flex-direction: column;\n    gap: 5px;\n    cursor: pointer;\n    border: 0;\n    background-color: #fff;\n    padding: 5px;\n    border-radius: 5px;\n}\n\n.collapse-menu:hover,\n.collapse-menu:focus-visible {\n    background-color: #e6e6e6;\n    outline: 2px solid #62a1d4;\n    outline-offset: 2px;\n}\n\n.collapse-menu .bar {\n    width: 25px;\n    height: 3px;\n    background-color: #555;\n    border-radius: 2px;\n}\n\n@media (max-width: 768px) {\n    .navbar-home,\n    .navbar-data {\n        box-sizing: border-box;\n        max-width: none;\n        width: 100%;\n        padding: 0 20px;\n    }\n\n    .navbar-menu {\n        display: none;\n    }\n\n    .navbar-menu.is-open {\n        display: flex;\n        flex-direction: column;\n        position: absolute;\n        top: 50px;\n        left: 0;\n        width: 100%;\n        padding: 0;\n        background-color: #000;\n        box-shadow: 0 4px 8px rgba(0,0,0,0.3);\n        z-index: 2000;\n    }\n\n    .navbar-menu.is-open > li {\n        width: 100%;\n    }\n\n    .navbar-menu.is-open a {\n        line-height: 1.4;\n        padding: 14px 20px;\n    }\n\n    .navbar-menu.is-open .dropdown-menu {\n        position: static;\n        display: block;\n        min-width: 0;\n        box-shadow: none;\n    }\n\n    .navbar-menu.is-open .dropdown-menu a {\n        padding-left: 40px;\n    }\n\n    .collapse-menu {\n        display: flex;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
